import { ReactNode } from "react";
import "./Card.scss";
interface CardHeaderProps {
  width?: number;
  style?: any;
  header?: ReactNode;
  className?: string;
}

const CardHeader: React.FC<CardHeaderProps> = (props) => {
  const { children, header, className, width = "100%", style } = props;
  return (
    <div
      className={`${className ?? ""} card-header`}
      style={{ width, ...style }}
    >
      {header && <div className="header">{header}</div>}
      <div className="body">{children}</div>
    </div>
  );
};

export default CardHeader;
